import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  loading: true,
  user: null,
  users: [],
  usersLoading: false,
  totalPages: 1,
  totalUsersCount: 0,
  bannedUsersCount: 0,
  adminUsersCount: 0,
  activeUsersCount: 0,
  error: null,
  successMessage: null,
};

export const userReducer = createReducer(initialState, {
  LoadUserRequest: (state) => { state.loading = true; },
  LoadUserSuccess: (state, action) => {
    state.isAuthenticated = true;
    state.loading = false;
    state.user = action.payload;
  },
  LoadUserFail: (state, action) => {
    state.loading = false;
    state.error = action.payload;
    state.isAuthenticated = false;
  },

  LogoutUserSuccess: (state) => {
    state.loading = false;
    state.isAuthenticated = false;
    state.user = null;
  },
  LogoutUserFail: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },

  updateUserInfoRequest: (state) => { state.loading = true; },
  updateUserInfoSuccess: (state, action) => {
    state.loading = false;
    state.user = action.payload;
    state.successMessage = "Profile updated successfully!";
  },
  updateUserInfoFailed: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },

  updateUserAddressRequest: (state) => { state.loading = true; },
  updateUserAddressSuccess: (state, action) => {
    state.loading = false;
    state.user = action.payload;
    state.successMessage = "Address updated successfully!";
  },
  updateUserAddressFailed: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },

  deleteUserAddressRequest: (state) => { state.loading = true; },
  deleteUserAddressSuccess: (state, action) => {
    state.loading = false;
    state.user = action.payload;
    state.successMessage = "Address deleted successfully!";
  },
  deleteUserAddressFailed: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },

  getAllUsersRequest: (state) => { state.usersLoading = true; },
  getAllUsersSuccess: (state, action) => {
    state.usersLoading = false;
    state.users = action.payload.users;
    state.totalPages = action.payload.totalPages;
    state.totalUsersCount = action.payload.totalUsers;
    state.bannedUsersCount = action.payload.bannedUsers;
    state.adminUsersCount = action.payload.adminUsers;
    state.activeUsersCount = action.payload.activeUsers;
  },
  getAllUsersFailed: (state, action) => {
    state.usersLoading = false;
    state.error = action.payload;
  },

  clearErrors: (state) => { state.error = null; },
  clearMessages: (state) => { state.successMessage = null; },
});
